import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { STORAGE_KEYS } from "@/config";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, loading, error } = useAuth();
  
  console.log('ProtectedRoute - session:', session?.user?.id, 'loading:', loading, 'error:', error);

  if (loading) {
    return (
      <main className="min-h-[50vh] grid place-items-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </main>
    );
  }

  if (error) {
    console.log('ProtectedRoute - redirecting to splash due to error:', error);
    return <Navigate to="/" replace />;
  }

  const isGuest = typeof window !== "undefined" && localStorage.getItem(STORAGE_KEYS.GUEST) === "true";

  if (!session && !isGuest) {
    console.log('ProtectedRoute - redirecting to auth, no session and not guest');
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
